module.exports = __webpack_public_path__ + "static/media/icon_here.6db728f6.svg";